import * as React from "react";
import { Avatar, Button, Flex, Image, Segment, Text } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import { CommonHelper } from '../../../helpers/common-helper';

interface IQueueWelcomeProps extends WithTranslation {
    botWriting: boolean;
    appConfigs: any;
    appSettings: any;
    meetingData: any;
    meetingQueueData: any;
    daysOfWeekLocale: any;
}

const QueueWelcomeCard: React.FunctionComponent<IQueueWelcomeProps> = props => {
    const localize = props.t;

    return (
        <Flex gap="gap.medium" className="firstCard card">
            <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
            <Image hidden={!props.botWriting} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />

            <Flex.Item grow>
                <Segment
                    hidden={props.botWriting}
                    className="dialog1 dialog"
                    content={
                        <Flex gap="gap.large" column>
                            <Text className="header-text" content={localize("BemVindo")} />
                            {/*<span className="welcome-header">Olá, Seja bem vindo ao <strong>Balcão Virtual</strong>.</span>*/}

                            <Flex gap="gap.medium" space="between">
                                <Flex gap="gap.medium" column>
                                    <Flex gap="gap.smaller">
                                        <Text
                                            styles={{ marginRight: '0.4rem !important' }}
                                            weight="light"
                                            size="medium"
                                            content={
                                                <React.Fragment>
                                                    <div>{localize("VoceEsta")}: <span className="bolder">{props.meetingData.name}</span></div>
                                                </React.Fragment>}
                                        />
                                    </Flex>

                                    {props.meetingData.descricao &&
                                        <Flex gap="gap.smaller">
                                            <Text
                                                styles={{ marginRight: '0.4rem !important', whiteSpace: 'pre-line' }}
                                                weight="light" size="medium"
                                                content={props.meetingData.descricao}
                                            />
                                        </Flex>
                                    }

                                    {(props.meetingData.horarioAtendimentoDias != "" &&
                                        props.meetingData.horarioAtendimentoFinal != "" &&
                                        props.meetingData.horarioAtendimentoInicial != "") &&
                                        <Flex gap="gap.smaller" inline>
                                            <Text
                                                styles={{ marginRight: '0.4rem !important' }}
                                                weight="light"
                                                size="medium"
                                                content={
                                                    <React.Fragment>
                                                        <div>{localize("NossoHorario")}&nbsp;
                                                            <span className="light-hightlight">
                                                                {props.daysOfWeekLocale(props.meetingData.horarioAtendimentoDias)}, {localize("Das")} {props.meetingData.horarioAtendimentoInicial} {localize("Ate")} {props.meetingData.horarioAtendimentoFinal}
                                                                &nbsp;{localize("HorarioBrasilia")}.
                                                            </span>
                                                        </div>
                                                    </React.Fragment>
                                                } />
                                        </Flex>
                                    }

                                    {props.meetingQueueData.schedule ?
                                        <Flex gap="gap.smaller" column>
                                            <Text styles={{ marginBottom: '0px !important' }} weight="light" size="medium" content={`Você está no canal de agendamento.`} />
                                            <Text weight="light" size="medium" content={localize("FavorAguarde")} />
                                        </Flex>
                                        :
                                        <Flex gap="gap.smaller" column>
                                            <Text styles={{ marginBottom: '0px !important' }} weight="light" size="medium" content={localize("VamosLa")} />
                                            <Text weight="light" size="medium" content={localize("FavorAguarde")} />
                                        </Flex>
                                    }
                                </Flex>

                                <Flex hAlign="center" className="welcome-queue">
                                    {props.appConfigs && props.appConfigs.imgWelcome != "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src={props.appConfigs.imgWelcome} />
                                        </Flex.Item>
                                    }

                                    {props.appConfigs && props.appConfigs.imgWelcome == "" &&
                                        <Flex.Item align="center" className="welcome">
                                            {props.meetingQueueData.schedule ?
                                                <Image styles={{ height: "22rem", margin: "2rem 0" }} src="https://studio365cdn.azureedge.net/balcaovirtual/welcome-scheduled.svg" /> :
                                                <Image src="https://studio365cdn.azureedge.net/balcaovirtual/welcome.svg" />
                                            }
                                        </Flex.Item>
                                    }
                                </Flex>
                            </Flex>
                            

                            <Flex gap="gap.small">
                                {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                    <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                }

                                {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                    <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                }
                            </Flex>
                        </Flex>
                    }
                />
            </Flex.Item>
        </Flex>
    );
};

const queueWelcomeWithTranslation = withTranslation()(QueueWelcomeCard);
export default queueWelcomeWithTranslation;